export default __webpack_public_path__ + "static/media/blog-padron2.6a00efd0.jpg";